export const ROOT_URL = process.env.REACT_APP_ROOT_URL_EVALU || "http://localhost:3000";

export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || "http://localhost:8080/users/login";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const OUTLOOK_CLIENT_ID = process.env.REACT_APP_OUTLOOK_CLIENT_ID;

const YAHOO_CLIENT_ID = process.env.REACT_APP_YAHOO_CLIENT_ID;

export const OAUTH_PROVIDERS = {
  google: {
    authUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    clientId: GOOGLE_CLIENT_ID,
    scope: "openid email profile",
    extraParams: {
      access_type: "offline",
      include_granted_scopes: "true",
      prompt: "consent",
    },
  },
  outlook: {
    authUrl: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    clientId: OUTLOOK_CLIENT_ID,
    scope: "openid email profile offline_access User.Read",
    extraParams: {
      response_mode: "query",
    },
  },
  yahoo: {
    authUrl: "https://api.login.yahoo.com/oauth2/request_auth",
    clientId: YAHOO_CLIENT_ID,
    scope: "openid email profile",
    extraParams: {
      response_mode: "query",
      nonce: randomString(16),
    },
  },
};

export const PKCE_STATE_KEY = "oauth_state";
export const PKCE_VERIFIER_KEY = "code_verifier";
export const PKCE_PROVIDER_KEY = "oauth_provider";

function randomString(len = 32) {
  const arr = new Uint8Array(len);
  window.crypto.getRandomValues(arr);
  return btoa(String.fromCharCode(...arr))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

async function sha256(str) {
  const data = new TextEncoder().encode(str);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export async function buildLoginUrl(provider = "google") {
  const config = OAUTH_PROVIDERS[provider];
  if (!config) {
    throw new Error(`Proveedor OAuth no soportado: ${provider}`);
  }

  const state = randomString(32);
  sessionStorage.setItem(PKCE_STATE_KEY, state);
  sessionStorage.setItem(PKCE_PROVIDER_KEY, provider);

  const usePkce = true;
  let pkce = {};
  if (usePkce) {
    const codeVerifier = randomString(64);
    const codeChallenge = await sha256(codeVerifier);
    sessionStorage.setItem(PKCE_VERIFIER_KEY, codeVerifier);
    pkce = {
      code_challenge: codeChallenge,
      code_challenge_method: "S256",
    };
  }

  const params = new URLSearchParams({
    client_id: config.clientId,
    response_type: "code",
    redirect_uri: REDIRECT_URI,
    scope: config.scope,
    state,
    ...config.extraParams,
    ...pkce,
  });

  return `${config.authUrl}?${params.toString()}`;
}
